import type { StyledComponent } from "@emotion/styled";
import styled from "@emotion/styled";
import * as Sentry from "@sentry/nextjs";
import type { FunctionComponent } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { notEmpty } from "shared/lib/utils";

import {
  SCMPYoutube,
  type ExtraProps as YoutubeExtraProps,
} from "scmp-app/components/schema-render/common/iframe/scmp-youtube";
import type { ContentSchemaRenderProps } from "scmp-app/components/schema-render/content";

import { DataWrapperIframe } from "./data-wrapper";
import { GenericIframe } from "./generic-iframe";
import { hasDataYoutubeIdAttributes, isDataWrapper, isYoutubeVideo } from "./helpers";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ComponentMap: Record<string, StyledComponent<any, any>> = {
  DataWrapper: DataWrapperIframe,
  Generic: GenericIframe,
  Youtube: SCMPYoutube,
};

export type Props = ContentSchemaRenderProps &
  YoutubeExtraProps & {
    "data-youtube-id"?: string;
    src?: string;
  };

const Component: FunctionComponent<Props> = ({ src, ...attribs }) => {
  const getIframeComponent = () => {
    // TODO: check if it's quiz
    if (!notEmpty(src)) return "";
    // will use placeholder for server side first then replace with youtube component at client side
    if (isYoutubeVideo(src) || hasDataYoutubeIdAttributes(attribs)) return "Youtube";
    if (isDataWrapper(src)) return "DataWrapper";
    return "Generic";
  };

  const Component = ComponentMap[getIframeComponent()];
  return Component ? (
    <ErrorBoundary fallback={<></>} onError={error => Sentry.captureException(error)}>
      <Component {...{ ...attribs, src }} />
    </ErrorBoundary>
  ) : null;
};

Component.displayName = "Iframe";
export const Iframe = styled(Component)``;
